import { z } from 'zod'

/**
 * The eight roles from BRD §3 plus the two production heads the client asked for in October.
 * The identifiers are stable and stored in the database; the Ukrainian labels are display-only
 * and may be reworded without a migration.
 */
export const ROLES = [
  'admin',
  'sales',
  'engineer',
  'chief_engineer',
  'production_head',
  'cnc_head',
  'production',
  'storekeeper',
  'logistician',
  'accountant',
  'worker',
] as const

export const roleSchema = z.enum(ROLES)
export type Role = z.infer<typeof roleSchema>

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Адміністратор / Керівник',
  sales: 'Менеджер з продажу',
  engineer: 'Конструктор / Інженер',
  chief_engineer: 'Головний конструктор',
  production_head: 'Начальник виробництва',
  cnc_head: 'Начальник дільниці ЧПУ',
  production: 'Виробництво (цех)',
  storekeeper: 'Комірник (склад)',
  logistician: 'Логіст',
  accountant: 'Бухгалтер',
  worker: 'Працівник цеху',
}

/**
 * Roles whose day-to-day work happens on a phone in the workshop. These are the accounts
 * routed to apps/shopfloor rather than the desktop CRM after sign-in.
 */
export const SHOPFLOOR_ROLES: readonly Role[] = ['worker', 'storekeeper', 'logistician']

export const isShopfloorRole = (role: Role): boolean => SHOPFLOOR_ROLES.includes(role)

/** Engineering staff: ordinary engineers and the chief engineer who distributes their work. */
export const ENGINEER_ROLES = ['engineer', 'chief_engineer'] as const satisfies readonly Role[]
export const isEngineerRole = (role: Role | string | null | undefined) =>
  role === 'engineer' || role === 'chief_engineer'
